import React from "react";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";
import { type DropdownProps } from "../models";

interface Option {
  value: server.dto.BookingRequestPageModes;
  label: string;
}

const options: Option[] = [{
  value: "fullFrame",
  label: RESX.Webform.FullHtmlFrame,
}, {
  value: "iFrame",
  label: RESX.Webform.InIFrame,
}]

const getPageModeOption = (value: server.dto.BookingRequestPageModes): Option | undefined => {
  return options.find(o => o.value === value);
}

export const getPageModeLabel = (value: server.dto.BookingRequestPageModes): string => {
  return getPageModeOption(value)?.label || "";
}

const PageModeDropdown = (props: DropdownProps<server.dto.BookingRequestPageModes>) => {
  const selectedOption = getPageModeOption(props.value);

  return <BaseReactSelectDropdown
    excludeKeys={[]}
    options={options}
    getLabel={v => v.label}
    getValue={(v) => v.value}
    value={selectedOption}
    onChange={(v) => props.onChange(v.value)}
    config={props.config}
  />;
};

export default PageModeDropdown;